import { Component, OnInit } from '@angular/core';
import { CookieConsentService } from '../../../services/cookie-consent/cookie-consent.service';

@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  styleUrls: []
})
export class CookieConsentComponent implements OnInit {
  showConsent = false;

  constructor(private cookieConsentService: CookieConsentService) {}

  ngOnInit(): void {
    // Show the cookie consent if user hasn't given consent yet
    this.showConsent = !this.cookieConsentService.hasConsent();
  }

  acceptAll(): void {
    this.cookieConsentService.acceptAll();
    this.showConsent = false;
  }

  acceptNecessary(): void {
    this.cookieConsentService.acceptNecessaryOnly();
    this.showConsent = false;
  }
}